import { defineComponent as _defineComponent } from 'vue'

import _ from 'lodash'
import { saveAs } from 'file-saver'
import Util from '@/utils/util.js'
import xlsx from 'xlsx'
import AV from 'leancloud-storage'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// import { ref } from 'vue'
// const aa = ref(111)
const deal = async () => {
  // 获取所有的年级
  // 获取所有的题型
  // 获取所有的单元
  // 获取所有的题目
  // 获取图片+音频资料

  const allGrade = await new AV.Query('LJLGrade').find()
  const allQuestionType = await new AV.Query('LJLQuestionType').ascending('series').find()
  console.log(allGrade, allQuestionType)
  await downloadAllStudent(allGrade[0], allQuestionType[0])
}

const downloadAllStudent = async (grade:any, questionType:any) => {
  const questions = await new AV.Query('LJLQuestion').equalTo('grade', grade).equalTo('questionType', questionType).limit(1000).find()
  console.log(questions)
  const data = [] as any
  for (let i = 0; i < questions.length; i++) {
    const question = questions[i]
    // console.log(question.get('questionData')[0].map(q => {
    //   return q.intro
    // }).join('\n\n'))
    data.push({
      年级: grade.get('name') + '-' + grade.get('series') + '单元',
      题型: questionType.get('name'),
      题干: question.get('questionData')[0].map(q => {
        if (question.get('questionData')[0].length === 1) {
          return q.intro
        }
        return q.sn + '.' + q.intro
      }).join('\n\n'),
      题干音频资料: question.get('questionData')[0].map(q => {
        if (q.voice && q.voice.url) {
          return '文件名：' + q.voice.name + '｜文件地址：(' + q.voice.url + ')' + '\n\n'
        }
        return ''
      }).join('\n\n'),
      题干图片资料: question.get('questionData')[0].map(q => {
        if (q.image && q.image.url) {
          return '文件名：' + q.image.name + '｜文件地址：(' + q.image.url + ')' + '\n\n'
        }
        return ''
      }).join('\n\n'),
      选项内容: question.get('questionData')[1].map(q => {
        return q.sn + '.' + q.intro
      }).join('\n\n'),
      标准答案: question.get('standardAnswerText') ? question.get('standardAnswerText') : question.get('answerSelection')[0].intro,
      选项音频资料: question.get('questionData')[1].map(q => {
        if (q.voice && q.voice.url) {
          return '文件名：' + q.voice.name + '｜文件地址：(' + q.voice.url + ')' + '\n\n'
        }
        return ''
      }).join('\n\n'),
      选项图片资料: question.get('questionData')[1].map(q => {
        if (q.image && q.image.url) {
          return '文件名：' + q.image.name + '｜文件地址：(' + q.image.url + ')' + '\n\n'
        }
        return ''
      }).join('\n\n')
    })
  }
  const header = ['年级', '题型', '题干', '题干音频资料', '题干图片资料', '选项内容', '标准答案', '选项音频资料', '选项图片资料']
  const worksheet = xlsx.utils.json_to_sheet(data, { header })
  const wb = xlsx.utils.book_new()
  xlsx.utils.book_append_sheet(wb, worksheet, grade.get('name') + '-' + grade.get('series') + '单元')
  const workbookBlob = _workbook2blob(wb)
  saveAs(workbookBlob, '蓝鲸灵' + grade.get('name') + '-' + grade.get('series') + '单元' + '.xls')
}
// 将workbook装化成blob对象
const _workbook2blob = (workbook) => {
  // 生成excel的配置项
  var wopts = {
    // 要生成的文件类型
    bookType: 'xls',
    bookSST: false,
    type: 'binary'
  } as any
  var wbout = xlsx.write(workbook, wopts)
  // 将字符串转ArrayBuffer
  function s2ab (s) {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  }
  var blob = new Blob([s2ab(wbout)], {
    type: 'application/octet-stream'
  })
  return blob
}

return (_ctx: any,_cache: any) => {
  return null
}
}

})